/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { polarisSettingsAccessRoute } from '@jira/router-routes__polaris-routes/src/polarisSettingsAccessRoute.tsx';
import { AccessSettingsPage, LazyAccessSettingsPage } from './ui/settings/access/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const polarisSettingsAccessRouteEntry: Route = createEntry(
	polarisSettingsAccessRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: AccessSettingsPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		forPaint: [LazyAtlassianNavigation, LazyAccessSettingsPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
